import React from "react"
import { Button, Dropdown, Switch, Tag, Tooltip } from "antd"
import { MoreOutlined } from "@ant-design/icons"

export const getColumns = (getMenuItems, isMutating, t, lineItemToggles = {}, onToggleLineItem, togglingFeeId = null) => [
  {
    title: t("settings.column_title"),
    dataIndex: "title",
    key: "title"
  },
  {
    title: t("settings.column_price"),
    dataIndex: "price",
    key: "price",
    render: (value, record) =>
      record.fee_type === "percentage" ? `${Number(value)?.toFixed(2)}%` : `$${Number(value)?.toFixed(2)}`,
    width: 150
  },
  {
    title: t("settings.column_status"),
    dataIndex: "is_active",
    key: "status",
    width: 120,
    render: (status) =>
      status ? (
        <Tag color="success">{t("settings.status_active")}</Tag>
      ) : (
        <Tag color="default">{t("settings.status_inactive")}</Tag>
      )
  },
  {
    title: "Separate Line Item",
    key: "show_as_line_item",
    width: 160,
    render: (_, record) => {
      const isToggling = togglingFeeId === record.id
      return (
        <Tooltip title={!record.is_active ? "Activate this fee to show it as a line item" : ""}>
          <Switch
            checked={!!lineItemToggles[record.id]}
            onChange={(checked) => onToggleLineItem?.(record.id, checked)}
            disabled={isMutating || !record.is_active}
            loading={isToggling}
            size="small"
          />
        </Tooltip>
      )
    }
  },
  {
    title: "",
    key: "actions",
    align: "right",
    width: 60,
    render: (_, record) => (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items: getMenuItems(record) }} trigger={["click"]} placement="bottomRight" disabled={isMutating}>
          <Button type="text" icon={<MoreOutlined />} />
        </Dropdown>
      </div>
    )
  }
]
